import orders from "@/apis/orders";
import { ordersTypes } from "@/store/mutationTypes";

export default {
  namespaced: true,
  state: {
    all: [],
    errors: [],
    uncompleted: [],
    fetchAll: {
      pending: false,
      error: null,
    },
    fetchOne: {
      pending: false,
      error: null,
    },
    fetchErrors: {
      pending: false,
      error: null,
    },
    fetchErrorContent: {
      pending: false,
      error: null,
    },
    deleteError: {
      pending: false,
      error: null,
    },
    retryError: {
      pending: false,
      error: null,
    },
    fetchUncompleted: {
      pending: false,
      error: null,
    },
    normalize: {
      pending: false,
      error: null,
    },
    fetchTimeseries: {
      pending: false,
      error: null,
    },
  },
  mutations: {
    [ordersTypes.FETCH_ALL_REQUEST]: function(state) {
      state.fetchAll.pending = true;
      state.fetchAll.error = null;
    },
    [ordersTypes.FETCH_ALL_SUCCESS]: function(state, orders) {
      state.fetchAll.error = null;
      state.fetchAll.pending = false;
      state.all = orders;
    },
    [ordersTypes.FETCH_ALL_FAILURE]: function(state, error) {
      state.fetchAll.error = error;
      state.fetchAll.pending = false;
    },
    [ordersTypes.FETCH_ONE_REQUEST]: function(state) {
      state.fetchOne.pending = true;
      state.fetchOne.error = null;
    },
    [ordersTypes.FETCH_ONE_SUCCESS]: function(state) {
      state.fetchOne.error = null;
      state.fetchOne.pending = false;
    },
    [ordersTypes.FETCH_ONE_FAILURE]: function(state, error) {
      state.fetchOne.error = error;
      state.fetchOne.pending = false;
    },
    [ordersTypes.FETCH_ERRORS_REQUEST]: function(state) {
      state.fetchErrors.pending = true;
      state.fetchErrors.error = null;
    },
    [ordersTypes.FETCH_ERRORS_SUCCESS]: function(state, errors) {
      state.fetchErrors.error = null;
      state.fetchErrors.pending = false;
      state.errors = errors;
    },
    [ordersTypes.FETCH_ERRORS_FAILURE]: function(state, error) {
      state.fetchErrors.error = error;
      state.fetchErrors.pending = false;
    },
    [ordersTypes.FETCH_ERROR_CONTENT_REQUEST]: function(state) {
      state.fetchErrorContent.pending = true;
      state.fetchErrorContent.error = null;
    },
    [ordersTypes.FETCH_ERROR_CONTENT_SUCCESS]: function(state) {
      state.fetchErrorContent.error = null;
      state.fetchErrorContent.pending = false;
    },
    [ordersTypes.FETCH_ERROR_CONTENT_FAILURE]: function(state, error) {
      state.fetchErrorContent.error = error;
      state.fetchErrorContent.pending = false;
    },
    [ordersTypes.DELETE_ERROR_REQUEST]: function(state) {
      state.deleteError.pending = true;
      state.deleteError.error = null;
    },
    [ordersTypes.DELETE_ERROR_SUCCESS]: function(state) {
      state.deleteError.error = null;
      state.deleteError.pending = false;
    },
    [ordersTypes.DELETE_ERROR_FAILURE]: function(state, error) {
      state.deleteError.error = error;
      state.deleteError.pending = false;
    },
    [ordersTypes.RETRY_ERROR_REQUEST]: function(state) {
      state.retryError.pending = true;
      state.retryError.error = null;
    },
    [ordersTypes.RETRY_ERROR_SUCCESS]: function(state) {
      state.retryError.error = null;
      state.retryError.pending = false;
    },
    [ordersTypes.RETRY_ERROR_FAILURE]: function(state, error) {
      state.retryError.error = error;
      state.retryError.pending = false;
    },
    [ordersTypes.FETCH_UNCOMPLETED_REQUEST]: function(state) {
      state.fetchUncompleted.pending = true;
      state.fetchUncompleted.error = null;
    },
    [ordersTypes.FETCH_UNCOMPLETED_SUCCESS]: function(state, uncompleted) {
      state.fetchUncompleted.error = null;
      state.fetchUncompleted.pending = false;
      state.uncompleted = uncompleted;
    },
    [ordersTypes.FETCH_UNCOMPLETED_FAILURE]: function(state, error) {
      state.fetchUncompleted.error = error;
      state.fetchUncompleted.pending = false;
    },
    [ordersTypes.NORMALIZE_REQUEST]: function(state) {
      state.normalize.pending = true;
      state.normalize.error = null;
    },
    [ordersTypes.NORMALIZE_SUCCESS]: function(state) {
      state.normalize.error = null;
      state.normalize.pending = false;
    },
    [ordersTypes.NORMALIZE_FAILURE]: function(state, error) {
      state.normalize.error = error;
      state.normalize.pending = false;
    },
    [ordersTypes.FETCH_TIMESERIES_REQUEST]: function(state) {
      state.fetchTimeseries.pending = true;
      state.fetchTimeseries.error = null;
    },
    [ordersTypes.FETCH_TIMESERIES_SUCCESS]: function(state) {
      state.fetchTimeseries.error = null;
      state.fetchTimeseries.pending = false;
    },
    [ordersTypes.FETCH_TIMESERIES_FAILURE]: function(state, error) {
      state.fetchTimeseries.error = error;
      state.fetchTimeseries.pending = false;
    },
  },
  actions: {
    async fetchAll({ commit }, payload) {
      commit(ordersTypes.FETCH_ALL_REQUEST);
      return new Promise((resolve, reject) => {
        orders
          .fetchAll(
            payload.number,
            payload.day,
            payload.kitchenUuid,
            payload.conceptUuid,
            payload.platformUuid,
            payload.country_code,
            payload.summary
          )
          .then(({ data }) => {
            commit(ordersTypes.FETCH_ALL_SUCCESS, data);
            resolve(data);
          })
          .catch((error) => {
            commit(ordersTypes.FETCH_ALL_FAILURE, error);
            reject(error);
          });
      });
    },
    async fetchOne({ commit }, payload) {
      commit(ordersTypes.FETCH_ONE_REQUEST);
      return new Promise((resolve, reject) => {
        orders
          .fetchOne(payload.uuid)
          .then(({ data }) => {
            commit(ordersTypes.FETCH_ONE_SUCCESS, data);
            resolve(data);
          })
          .catch((error) => {
            commit(ordersTypes.FETCH_ONE_FAILURE, error);
            reject(error);
          });
      });
    },
    fetchErrorsSummary() {
      return orders.fetchErrorsSummary().then((response) => response.data);
    },
    fetchErrors({ commit }, payload) {
      commit(ordersTypes.FETCH_ERRORS_REQUEST);
      return new Promise((resolve, reject) => {
        orders
          .fetchErrors(payload.page, payload.pageSize)
          .then(({ data }) => {
            commit(ordersTypes.FETCH_ERRORS_SUCCESS, data);
            resolve(data);
          })
          .catch((error) => {
            commit(ordersTypes.FETCH_ERRORS_FAILURE, error);
            reject(error);
          });
      });
    },
    fetchErrorContent({ commit }, payload) {
      commit(ordersTypes.FETCH_ERROR_CONTENT_REQUEST);
      return new Promise((resolve, reject) => {
        orders
          .getErrorContent(payload.path)
          .then(({ data }) => {
            commit(ordersTypes.FETCH_ERROR_CONTENT_SUCCESS);
            resolve(data);
          })
          .catch((error) => {
            commit(ordersTypes.FETCH_ERROR_CONTENT_FAILURE, error);
            reject(error);
          });
      });
    },
    deleteError({ commit }, payload) {
      commit(ordersTypes.DELETE_ERROR_REQUEST);
      return new Promise((resolve, reject) => {
        orders
          .deleteError(payload.path)
          .then(() => {
            commit(ordersTypes.DELETE_ERROR_SUCCESS);
            resolve();
          })
          .catch((error) => {
            commit(ordersTypes.DELETE_ERROR_FAILURE, error);
            reject(error);
          });
      });
    },
    retryError({ commit }, payload) {
      commit(ordersTypes.RETRY_ERROR_REQUEST);
      return new Promise((resolve, reject) => {
        orders
          .retryError(payload.path, payload.topic_name, payload.error_path)
          .then(() => {
            commit(ordersTypes.RETRY_ERROR_SUCCESS);
            resolve();
          })
          .catch((error) => {
            commit(ordersTypes.RETRY_ERROR_FAILURE, error);
            reject(error);
          });
      });
    },
    fetchUncompleted({ commit }) {
      commit(ordersTypes.FETCH_UNCOMPLETED_REQUEST);
      return new Promise((resolve, reject) => {
        orders
          .fetchUncompletedOrders()
          .then(({ data }) => {
            commit(ordersTypes.FETCH_UNCOMPLETED_SUCCESS, data);
            resolve(data);
          })
          .catch((error) => {
            commit(ordersTypes.FETCH_UNCOMPLETED_FAILURE, error);
            reject(error);
          });
      });
    },
    normalize({ commit }, payload) {
      commit(ordersTypes.NORMALIZE_REQUEST);
      return new Promise((resolve, reject) => {
        orders
          .normalizeOrder(payload.uuid)
          .then(() => {
            commit(ordersTypes.NORMALIZE_SUCCESS);
            resolve();
          })
          .catch((error) => {
            commit(ordersTypes.NORMALIZE_FAILURE, error);
            reject(error);
          });
      });
    },
    fetchTimeseries({ commit }, payload) {
      commit(ordersTypes.FETCH_TIMESERIES_REQUEST);
      return new Promise((resolve, reject) => {
        orders
          .fetchTimeseries(
            payload.kitchenUuid,
            payload.locationUuid,
            payload.conceptUuid,
            payload.startDate,
            payload.endDate,
            payload.startMinute,
            payload.endMinute,
            payload.interval
          )
          .then(({ data }) => {
            commit(ordersTypes.FETCH_TIMESERIES_SUCCESS);
            resolve(data);
          })
          .catch((error) => {
            commit(ordersTypes.FETCH_TIMESERIES_FAILURE, error);
            reject(error);
          });
      });
    },
    fetchPipelineEvents(_, payload) {
      return orders.fetchPipelineEvents(payload);
    },
    getPipelineEvent(_, eventId) {
      return orders.getPipelineEvent(eventId);
    },
    retryPipelineEvent(_, { eventId, payload }) {
      return orders.retryPipelineEvent(eventId, payload);
    },
    ignorePipelineEvent(_, eventId) {
      return orders.ignorePipelineEvent(eventId);
    },
  },
};
